<div class="row">
    <div class="col s12 m1 offset-m11">
        <div class="fixed-action-btn toolbar" id="menu" #menu>
            <a class="btn-floating btn-large">
                <i class="large material-icons">filter_list</i>
            </a>
            <ul>
                <li><a class="btn-floating" routerLink="" routerLinkActive="active">HOME</a></li>
                <li><a class="btn-floating" routerLink="/conversemos" routerLinkActive="active">Contacto</a></li>
                <li><a class="btn-floating" routerLink="/bio" routerLinkActive="active">Bio</a></li>
                <li><a class="btn-floating" routerLink="/favorites-codes" routerLinkActive="active">Proyectos</a>
                </li>
                <li><a class="btn-floating" routerLink="/CaritoDaSilvaCV" routerLinkActive="active">CV</a></li>
            </ul>
        </div>
    </div>
</div>
<router-outlet></router-outlet>